import React from 'react';
import Helmet from 'react-helmet';

import Layout from 'components/Layout';
import Container from 'components/Container';

const SecondPage = () => {
  return (
    <Layout pageName="two">
      <Helmet>
        <title>More Info</title>
      </Helmet>
      <Container type="content" className="text-center">
        <h1>CDC Guidelines</h1>
        <p>There is currently no vaccine to prevent coronavirus disease 2019 (COVID-19).
  <ul><li>The best way to prevent illness is to avoid being exposed to this virus.</li>
<li>The virus is thought to spread mainly from person-to-person.
<ul><li>Between people who are in close contact with one another (within about 6 feet).</li>
<li>Through respiratory droplets produced when an infected person coughs, sneezes or talks.</li>
<li>These droplets can land in the mouths or noses of people who are nearby or possibly be inhaled into the lungs.</li>
<li>Some recent studies have suggested that COVID-19 may be spread by people who are not showing symptoms.</li></ul></li></ul>
<a href="https://www.cdc.gov/coronavirus/2019-ncov/prevent-getting-sick/prevention.html" target="_blank">Read more </a>
  </p>
      </Container>
    </Layout>
  );
};

export default SecondPage;
